<template>
  <div class="logins" :style="{ backgroundImage: bgImg }">
    <div class="log_left"></div>
    <div class="logins_rig">
      <div class="all_logo">
        <div class="logos">
          <div class="logos_imgs">
            <img v-if="$store.state.uiConfig['loginPageLogo'] !== 'off'" :src="logImgUrl" alt="" />
          </div>
        </div>

        <div class="cons_no"
          v-if="systemMaintainInfos&&systemMaintainInfos.trim() == '<p><br></p>' || systemMaintainInfos==''">
          {{ $translate('editableRegion') }}
        </div>
        <div class="cons ql-editor" v-else v-html="$xss.process(systemMaintainInfos) || ''">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { baseUrl } from "../../config/env.js";

export default {
  name: "Login",
  data() {
    return {
      loginType: "userLogin",
      showType: true,
      logImgUrl: baseUrl + "/resourceFile/logo.png?t=" + Math.random(),
      showWarn: true,
    };
  },
  computed: {
    ...mapState(["systemType"]),

    bgImg() {
      if (
        this.$store.state.systemConfig["backgroundPicture"] &&
        this.$store.state.uiConfig["customBackgroundImage"] !== "off"
      ) {
        return `url(${this.$store.state.systemConfig["backgroundPicture"]})`;
      } else {
        const bgMapping = {
          earthClient: "bgzh.png",
          jd: "bgzh.png",
          zongteng: "bgzh.png",
          ATL: "ATL/ATLBG.jpg",
        };
        const img = require(`../../assets/${bgMapping[this.systemType]}`);
        return `url(${img})`;
      }
    },

    systemMaintainInfos() {
      let themeId = this.$store.state.systemConfig.systemMaintainInfo
        ? this.$store.state.systemConfig.systemMaintainInfo
        : "";
      return themeId;
    },
  },
  destroyed() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
$ATL-color: #00a0e9;
.logos_imgs {
  width: 100%;
  display: flex;
  margin: 0 auto;
  img {
    width: 100%;
  }
}

.logins {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  .log_left {
    width: 57%;
  }

  .logins_rig {
    width: 40%;
    position: relative;
  }
  .all_logo {
    width: 100%;
    margin-top: 20%;
  }

  .logos {
    .logos_h {
      font-size: 22px;
      font-weight: bold;
      text-align: center;
    }
    .logos_p {
      font-size: 20px;
      text-align: center;
      font-weight: 700;
      letter-spacing: 1px;
      padding-top: 20px;
      color: #333333;
    }
  }
  .cons_no {
    width: 60%;
    margin: 0 auto;
    height: 33vh;
    border: 2px solid #e9e9e9;
    background-color: #fafafa;
    opacity: 0.7;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2em;
    position: relative;
    left: 1%;
  }
  .cons {
    width: 80%;
    margin: 0 auto;
    height: 280px;
    // margin-top: 2.2em;
    position: absolute;
    top: 46.5%;
    left: 12%;
    transform: translate(0%);
  }
}
@media only screen and (min-width: 321px) and (max-width: 1024px) {
  .login {
    background-size: 300% 100%;
    background: rgba(255, 255, 255, 0.5);
    .login_content {
      width: 100%;
      .login_form {
        width: 80% !important;
      }
    }
  }
}
/deep/ .login_form {
  .el-input__prefix,
  .el-checkbox {
    color: inherit !important;
  }
}
/deep/ .login_form input:-internal-autofill-selected {
  color: inherit;
}
</style>
<style lang="scss">
.login_main {
  .el-checkbox__label {
    font-size: 12px;
  }
}
@import "../../assets/css/quill.bubble.css";
@import "../../assets/css/quill.core.css";
@import "../../assets/css/quill.snow.css";
</style>